namespace Matrix.Dashboards {
    export namespace DatasetService {
        export const baseUrl = 'Dashboards/Dataset';

        export declare function Create(request: Serenity.SaveRequest<DatasetRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<DatasetRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<DatasetRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<DatasetRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Fetch(request: DatasetFetchRequest, onSuccess?: (response: DatasetFetchResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ListColumns(request: DatasetListColumnsRequest, onSuccess?: (response: DatasetListColumnsResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ExtractParameters(request: DataSourceExtractParametersRequest, onSuccess?: (response: DataSourceExtractParametersResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ListParameters(request: DatasetListParametersRequest, onSuccess?: (response: DatasetListParametersResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Dashboards/Dataset/Create",
            Update = "Dashboards/Dataset/Update",
            Delete = "Dashboards/Dataset/Delete",
            Retrieve = "Dashboards/Dataset/Retrieve",
            List = "Dashboards/Dataset/List",
            Fetch = "Dashboards/Dataset/Fetch",
            ListColumns = "Dashboards/Dataset/ListColumns",
            ExtractParameters = "Dashboards/Dataset/ExtractParameters",
            ListParameters = "Dashboards/Dataset/ListParameters"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'Fetch', 
            'ListColumns', 
            'ExtractParameters', 
            'ListParameters'
        ].forEach(x => {
            (<any>DatasetService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
